import React from 'react';

export default function PageHeader({ kicker, title, lead }) {
  return (
    <header className="animate-fade-up">
      {kicker && (
        <p className="text-[11px] tracking-[0.4em] uppercase text-[var(--color-gold)] mb-4 font-medium">
          {kicker}
        </p>
      )}
      <h1 className="font-display text-4xl md:text-5xl lg:text-6xl text-navy leading-[1.05] mb-6 max-w-4xl">
        {title}
      </h1>
      <div className="h-px w-16 bg-[var(--color-gold)] mb-8" />
      {lead && <p className="text-lg text-navy/80 leading-relaxed text-justify">{lead}</p>}
    </header>
  );
}
